import { interfaces } from 'inversify';

export interface IAppConfig {
  readonly imageUploadBaseUrl: string;
  readonly trainingApiBaseUrl: string;
  readonly exportApiBaseUrl: string;
  readonly userAccountDeletionDelayDayCount: number;
  readonly concurrentUploadsCount: number;
  readonly supportEmailAddress: string;
  readonly imagePreloadRange: number;
  readonly reLockInterval: number;
  readonly concurrentAttachmentUploadsCount: number;
  readonly runLocally: boolean;
  readonly requiredClientVersion: string;
  readonly registrationEnabled: boolean;
  readonly emailDenyList: string[];
}

export interface IBaseConfiguration {
  readonly version: string;
  readonly baseUrl: string;
  readonly hubUrl: string;
  readonly projectHubUrl: string;
  readonly uploadsHubUrl: string;
}

export interface IConfiguration extends IBaseConfiguration {
  readonly appConfig: IAppConfig;
  setupAppConfig(appConfig: IAppConfig): void;
}

export namespace IConfiguration {
  export const $: interfaces.ServiceIdentifier<IConfiguration> = Symbol('CONFIGURATION');
}
